import { render } from "./EmptyHero.vue?vue&type=template&id=06d74041&scoped=true"
import script from "./EmptyHero.vue?vue&type=script&lang=js"
export * from "./EmptyHero.vue?vue&type=script&lang=js"

import "./EmptyHero.vue?vue&type=style&index=0&id=06d74041&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d74041"]])

export default __exports__